module.exports = require("@swa-ui/core/src/assets/styles/globalRules.module.scss");